import { Product } from '../';

export function IsProductWithSameColor(color?: string) {
  return function(product: Product): product is Product {
    return typeof product.drawableObject !== 'undefined' &&
      product.drawableObject?.color === color;
  }
}
